import { PlusOutlined } from '@ant-design/icons';
import { pendingFilterErrorSelector } from 'advanced-filters/selectors/filter';
import { resetPendingFilter, savePendingFilter } from 'advanced-filters/store/filter';
import { Alert, Button } from 'antd';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './SearchCriteria.module.scss';

export default function SearchCriteriaFooter() {
  const dispatch = useDispatch();
  const errorMessage = useSelector(pendingFilterErrorSelector);

  const handlePendingFilerReset = useCallback(() => {
    dispatch(resetPendingFilter());
  }, [dispatch]);

  const handleAddCriteria = useCallback(() => {
    dispatch(savePendingFilter());
  }, [dispatch]);

  return (
    <div className={styles.footer}>
      {errorMessage && <Alert message={errorMessage} type="error" showIcon />}
      <div className={styles.footerCta}>
        <Button
          icon={<PlusOutlined />}
          type="link"
          className={styles.primaryBtnClass}
          onClick={handleAddCriteria}
        >
          Add Criteria
        </Button>

        <Button
          type="text"
          className={styles.secondaryBtnClass}
          onClick={handlePendingFilerReset}
        >
          Reset
        </Button>
      </div>
    </div>
  );
}
